import { GlobalHeader } from '@/app/components/layout';

const BusinessHeader = () => {
  return <GlobalHeader />;
};

export default BusinessHeader;
